import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    component: () => import("./pages/HomePage.vue"),
    name: "home",
    path: "/",
  },
  {
    component: () => import("./pages/services/ServiceCategoriesPage.vue"),
    name: "services-categories",
    path: "/dienstleistungen",
  },
  {
    component: () => import("./pages/services/ServicesListPage.vue"),
    name: "services-list",
    path: "/dienstleistungen/:kategorie",
  },
  {
    component: () => import("./pages/services/ServiceStaffPage.vue"),
    name: "services-staff",
    path: "/dienstleistungen/:kategorie/:dienstleistung",
  },
  {
    component: () => import("./pages/services/ServiceDateTimePage.vue"),
    name: "services-datetime",
    path: "/dienstleistungen/:kategorie/:dienstleistung/:mitarbeiter",
  },
  {
    component: () => import("./pages/services/ServiceConfirmationPage.vue"),
    name: "services-confirmation",
    path: "/dienstleistungen/:kategorie/:dienstleistung/:mitarbeiter/bestaetigung",
  },
  {
    component: () => import("./pages/products/ProductCategoriesPage.vue"),
    name: "products-categories",
    path: "/produkte",
  },
  {
    component: () => import("./pages/products/ProductPickupTimePage.vue"),
    name: "products-pickup-time",
    path: "/produkte/warenkorb",
  },
  {
    component: () => import("./pages/products/ProductConfirmationPage.vue"),
    name: "products-confirmation",
    path: "/produkte/warenkorb/abschluss",
  },
  {
    component: () => import("./pages/products/ProductsListPage.vue"),
    name: "products-list",
    path: "/produkte/:kategorie",
  },
  {
    component: () => import("./pages/legal/ImpressumPage.vue"),
    name: "impressum",
    path: "/impressum",
  },
  {
    component: () => import("./pages/legal/AgbPage.vue"),
    name: "agb",
    path: "/agb",
  },
  {
    component: () => import("./pages/legal/DatenschutzPage.vue"),
    name: "datenschutz",
    path: "/datenschutz",
  },
  {
    component: () => import("./pages/legal/StornierungPage.vue"),
    name: "stornierung",
    path: "/stornierung",
  },
  {
    component: () => import("./pages/NewsletterUnsubscribePage.vue"),
    name: "newsletter-unsubscribe",
    path: "/newsletter/abmelden/:token",
  },
  {
    component: () => import("./pages/AppointmentConfirmPage.vue"),
    name: "appointment-confirm",
    path: "/termin/bestaetigen/:token",
  },
  {
    component: () => import("./pages/PickupConfirmPage.vue"),
    name: "pickup-confirm",
    path: "/abholung/bestaetigen/:token",
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.name === "home") {
      return {
        left: 0,
        top: 0,
      };
    }
    return {
      behavior: "smooth",
      el: "main",
      top: 0,
    };
  },
});
